/**
 * OrderPriceItem.jsx
 * Created by Stephanie Condrey on 11/14/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    orderPriceLabel: PropTypes.string,
    orderPrice: PropTypes.string
};

export default class OrderPriceItem extends React.Component {
    render() {
        return (
            <div className="rec-order-price-row">
                <p className="price-label">{this.props.orderPriceLabel}</p>
                <p className="price">{this.props.orderPrice}</p>
            </div>
        );
    }
}
OrderPriceItem.propTypes = propTypes;
